export const dataList = [
  {
    name: "保证金充值总额",
    tips: "保证金充值的总额，以保证金充值的支付成功时间为准",
  },
  {
    name: "保证金盒币充值总额",
    tips: "用盒币充值保证金的总额，以保证金充值的支付成功时间为准",
  },
  {
    name: "保证金支付宝充值金额",
    tips: "用交易币充值保证金的总额，以保证金充值的支付成功时间为准",
  },
  {
    name: "保证金退款总金额",
    tips: "保证金退款成功总金额，以退款时间为准",
  },
  {
    name: "保证金盒币退款金额",
    tips: "保证金退款成功中盒币退款总金额，以退款时间为准",
  },
  {
    name: "保证金支付宝退款金额",
    tips: "保证金退款成功中支付宝退款总金额，以退款时间为准",
  },
  {
    name: "保证金收入",
    tips: "状态为 买家已违约：保证金已补充给卖家的订单数量*（保证金金额-后台配置的盒币对应人民币金额）",
  },
];

export const numList = [
  {
    curr_num: 0,
    past_num: 0,
    radio_show: false,
    contrast_radio: 0,
  },
  {
    curr_num: 0,
    past_num: 0,
    radio_show: false,
    contrast_radio: 0,
  },
  {
    curr_num: 0,
    past_num: 0,
    radio_show: false,
    contrast_radio: 0,
  },
  {
    curr_num: 0,
    past_num: 0,
    radio_show: false,
    contrast_radio: 0,
  },
  {
    curr_num: 0,
    past_num: 0,
    radio_show: false,
    contrast_radio: 0,
  },
  {
    curr_num: 0,
    past_num: 0,
    radio_show: false,
    contrast_radio: 0,
  },
  {
    curr_num: 0,
    past_num: 0,
    radio_show: false,
    contrast_radio: 0,
  },
];

export const navList = [
  {
    id: 1,
    name: "保证金充值总额",
    list: [
      {
        name: "保证金总充值金额",
        key: "total_recharge_amount",
      },
      {
        name: "盒币充值总额",
        key: "balance_recharge_amount",
      },
      {
        name: "支付宝充值总额",
        key: "ali_recharge_amount",
      },
    ],
  },
  {
    id: 2,
    name: "保证金退款总额",
    list: [
      {
        name: "保证金退款成功总金额",
        key: "total_refund_amount",
      },
      {
        name: "保证金退款成功中盒币退款总金额",
        key: "balance_refund_amount",
      },
      {
        name: "保证金退款成功中支付宝退款总金额",
        key: "ali_refund_amount",
      },
    ],
  },
  {
    id: 3,
    name: "保证金收入",
    key: "total_extract_num",
  },
];

export const titleLineList = [
  {
    name: "保证金总充值金额",
    key: "total_recharge_amount",
  },
  {
    name: "盒币充值总额",
    key: "balance_recharge_amount",
  },
  {
    name: "支付宝充值总额",
    key: "ali_recharge_amount",
  },
  {
    name: "保证金退款成功总金额",
    key: "total_refund_amount",
  },
  {
    name: "保证金退款成功中盒币退款总金额",
    key: "balance_refund_amount",
  },
  {
    name: "保证金退款成功中支付宝退款总金额",
    key: "ali_refund_amount",
  },
  {
    name: "保证金收入",
    key: "total_extract_num",
  },
];
